module.exports = __webpack_public_path__ + "static/media/Story view 2.341f69b9.png";